import {$body} from '../Constants';
import HtmlElement from './HtmlElement';

/**
 * Image Slider
 */
class ImageSlider extends HtmlElement {
  onReady() {
    this.init();
  }

  init() {
    this.$element.owlCarousel({
      items: 1,
      navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      autoplay: true,
      autoplayHoverPause: true,
      loop: true
    });
  }
}

export default (new ImageSlider($body.find('.image-slider')));
